import { AddClientFormValues, ImageUploadValues } from "../types";
import { useRequest } from "../../../hooks/useRequest";
import { useState } from "react";
import routes from "../../../routes";
import useHttpResponseAlert from "../../../hooks/useHttpResponseAlert";
import { Alert } from "../../../hooks/useHttpResponseAlert";

function useAddClientForm() {
  const [isConfirmationDialogOpen, setConfirmationDialogOpen] =
    useState<boolean>(false);
  const [mergedAlert, setMergedAlert] = useState<Alert>(null);
  const [prevTextAlert, setPrevTextAlert] = useState<Alert>(null);
  const [prevImageAlert, setPrevImageAlert] = useState<Alert>(null);

  const {
    fetch: uploadText,
    response: responseText,
    error: errorText,
    loading: loadingText,
  } = useRequest();
  const {
    fetch: uploadImage,
    response: responseImage,
    error: errorImage,
    loading: loadingImage,
  } = useRequest();

  const { alert: textAlert } = useHttpResponseAlert(
    errorText,
    responseText,
    "Client has been added successfully!",
  );
  const { alert: imageAlert } = useHttpResponseAlert(
    errorImage,
    responseImage,
    "Client has been added successfully!",
  );

  if (textAlert !== prevTextAlert || imageAlert !== prevImageAlert) {
    setPrevTextAlert(textAlert);
    setPrevImageAlert(imageAlert);
    if (textAlert?.type === "error") {
      setMergedAlert(textAlert);
      setConfirmationDialogOpen(true);
    } else if (imageAlert?.type === "error") {
      setMergedAlert(imageAlert);
      setConfirmationDialogOpen(true);
    } else if (textAlert?.type === "success") {
      setMergedAlert(textAlert);
      setConfirmationDialogOpen(true);
    }
  }

  const handleSubmit: (
    form: AddClientFormValues,
    imageUploadValues: ImageUploadValues,
  ) => Promise<void> = async (
    form: AddClientFormValues,
    imageUploadValues: ImageUploadValues,
  ) => {
    const imageFile = imageUploadValues?.file;

    const payload = {
      client: {
        name: form["client-name"],
        pricingPlan: { level: form["client-pricing-plan"] },
        products: form["client-products"],
        isPrivateLedger: form["is-private-ledger"],
        address: {
          street: form["address-street"],
          city: form["address-city"],
          zipCode: form["address-zip-code"],
          country: form["country-select"]?.code,
        },
      },
      mainUser: {
        email: form.email,
        firstName: form["main-user-first-name"],
        lastName: form["main-user-last-name"],
      },
    };
    if (imageFile) {
      const formData = new FormData();
      formData.append("image", imageFile);
      uploadImage("POST", routes.api.client.addImageToNewClient({}), formData);
    }
    uploadText("POST", routes.api.client.add({}), payload);
  };

  return {
    handleSubmit,
    setConfirmationDialogOpen,
    isConfirmationDialogOpen,
    formSubmittalLoading: loadingText || loadingImage,
    formSuccess: responseText || responseImage,
    formAlert: mergedAlert,
  };
}

export default useAddClientForm;
